class Perfil{
    constructor(){
        this.id = null;
        this.nome = '';
        this.paginaInicial = '';
        this.idCliente = '';
    }
}

export default Perfil;